import {ComplaintStatus} from "@/enums/status";

export class ComplaintParams {
    page? = 1;
    limit? = 10;
    ladingCode?: string;
    fromDate?: number;
    toDate?: number;
    customerRowGuid?: string;
    status?: ComplaintStatus;
    employeeRowGuid?: string;
    createdByRowGuid?: string;
    createdByType?: number;
    constructor(page = 1, limit = 10, ladingCode?: string,
                fromDate?: number,
                toDate?: number,
                customerRowGuid?: string,
                status?: ComplaintStatus,
                employeeRowGuid?: string) {
        this.page = page;
        this.limit = limit;
        this.ladingCode = ladingCode;
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.customerRowGuid = customerRowGuid;
        this.status = status;
        this.employeeRowGuid = employeeRowGuid
    }

}
